export const API_ENDPOINTS = {
    GET_ORGANIZATION: '/organization',
    GET_POSITIONS: '/positions',
    GET_SITES: '/sites',
    GET_USERS: '/users'
}